module.exports = __webpack_public_path__ + "img/Juan.c3a6d26f.png";